import { FC } from 'react';

interface DateFilterProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    className?: string;
}

const DateFilter: FC<DateFilterProps> = ({ label, value, onChange, disabled = false, className = '' }) => {
    return (
        <div className={`flex items-center gap-2 ${className}`}>
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                {label}
            </label>
            <input
                type="date"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
                className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
            />
        </div>
    );
};

export default DateFilter;
